// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_pc-0";
export var animationContainer = "_pc-1";
export var itemPrice = "_pc-a";
export var itemizedContent = "_pc-9";
export var itemizedHeader = "_pc-7";
export var itemizedRow = "_pc-8";
export var itemizedSection = "_pc-6";
export var modalContent = "_pc-2";
export var orderName = "_pc-3";
export var refundOption = "_pc-4";
export var refundOptionsContainer = "_pc-5";
export var shippingLabel = "_pc-b";
export var totalRow = "_pc-c";